<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row flex-column-reverse flex-sm-row">
                        <div class="col-md-6">
                            <h2>CO2 Emissions</h2>
                        </div>
                        <div class="col-md-6 text-right">
                            <router-link to="/co2-emissions/import" class="btn btn-success">
                                Import CSV
                            </router-link>
                        </div>
                    </div>
                    
                    <messages :messages="messages"/>
                    
                    <!-- Search and Filters -->
                    <div class="row mb-3">
                        <div class="col-md-4">
                            <input 
                                v-model="search.chassis_number" 
                                @input="onSearch"
                                type="text" 
                                class="form-control" 
                                placeholder="Search by chassis number..."
                            >
                        </div>
                        <div class="col-md-3">
                            <input 
                                v-model="search.make" 
                                @input="onSearch"
                                type="text" 
                                class="form-control" 
                                placeholder="Search by make..."
                            >
                        </div>
                        <div class="col-md-3">
                            <input 
                                v-model="search.model" 
                                @input="onSearch"
                                type="text" 
                                class="form-control" 
                                placeholder="Search by model..."
                            >
                        </div>
                        <div class="col-md-2">
                            <input 
                                v-model="search.year" 
                                @input="onSearch"
                                type="number" 
                                class="form-control" 
                                placeholder="Year..."
                            >
                        </div>
                    </div>

                    <!-- Data Table Component -->
                    <DataTable 
                        :emissions="emissions" 
                        :loading="loading"
                        @page-change="loadEmissions"
                        @row-click="showEmissionDetails"
                    />
                </div>
            </div>
        </div>

        <!-- Emission Details Modal -->
        <EmissionModal 
            :show="showModal" 
            :emission="selectedEmission" 
            @close="closeModal"
        />
    </div>
</template>

<script>
import axios from 'axios'
import DataTable from './DataTable.vue'
import EmissionModal from './EmissionModal.vue'

export default {
    components: {
        DataTable,
        EmissionModal
    },
    data() {
        return {
            emissions: {
                data: [],
                current_page: 1,
                last_page: 1,
                per_page: 50,
                total: 0
            },
            loading: false,
            messages: [],
            search: {
                chassis_number: '',
                make: '',
                model: '',
                year: ''
            },
            searchTimeout: null,
            showModal: false,
            selectedEmission: null
        }
    },

    mounted() {
        this.loadEmissions()
    },
    methods: {
        async loadEmissions(page = 1) {
            this.loading = true
            try {
                const params = {
                    page: page,
                    per_page: this.emissions.per_page,
                    ...this.search
                }
                
                // Remove empty search parameters
                Object.keys(params).forEach(key => {
                    if (params[key] === '' || params[key] === null) {
                        delete params[key]
                    }
                })
                
                const response = await axios.get('/co2-emissions', { params })
                this.emissions = response.data
                this.messages = []
            } catch (error) {
                console.error('Error loading emissions:', error)
                this.messages = [{
                    type: 'danger',
                    message: 'Error loading emissions data'
                }]
            } finally {
                this.loading = false
            }
        },
        onSearch() {
            clearTimeout(this.searchTimeout)
            this.searchTimeout = setTimeout(() => {
                this.loadEmissions(1)
            }, 500)
        },
        showEmissionDetails(emission) {
            this.selectedEmission = emission
            this.showModal = true
        },
        closeModal() {
            this.showModal = false
            this.selectedEmission = null
        }
    }
}
</script>

<style scoped>
/* List page specific styles */
</style> 


// WEBPACK FOOTER //
// resources/js/components/Co2Emissions/List.vue